import * as React from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@material-ui/core';

interface IProps {
  open: boolean;
  title: string;
  description: string;
  onClose: any;
  closeButton: string;
}
export default function CopayAlertDialog(props: IProps): React.ReactElement {
  const {open, title, description, onClose, closeButton} = props;
  return (
    <div>
      <Dialog
        open={open}
        onClose={() => onClose()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={'md'}
        disableBackdropClick>
        <DialogTitle disableTypography>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => onClose()}
            autoFocus
            variant="contained"
            color="primary">
            {closeButton}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
